<template>
  <div class="order_detail_main">
    <div class="info_box">
      <div class="tit" style="padding-bottom: 0;">订单概要</div>
      <div class="base_info" v-if="detailInfo">
        <el-row>
          <label-item label="订单编号" :value="detailInfo.orderID"></label-item>
          <label-item label="创建时间" :value="timetrans(detailInfo.createTime)"></label-item>
          <label-item label="支付方式" value=金额支付"></label-item>

          <label-item label="订单类型" :value="handleOrderType(detailInfo.orderType)"></label-item>
          <label-item label="支付时间" :value="timetrans(detailInfo.payTime)"></label-item>
          <label-item
            label="交易状态"
            :value="payStateTxt"
            :valueStyle="{ color: handleOrderState(detailInfo.state, true) }"
          ></label-item>
          <label-item v-if="detailInfo.note" label="订单备注" :value="detailInfo.note"></label-item>
        </el-row>
      </div>
    </div>
    <!-- 订单详情 -->
    <div class="detail_info_box">
      <div class="tit">订单详情</div>
      <div class="detail_table">
        <public-table :loading="Loading" :column="column" :tableData="orderData">
          <template v-slot:appName="{ row }">
            <router-link :to="{name: 'enterpriseAppDetails', params:{appId: row.deliveryAppID}}">{{row.appName}}</router-link>
          </template>
          <template v-slot:comboNamedetail="{ row }">
            <div v-for="(item, index) in row.comboItems" :key="index" style="display: flex;">
              <div style="text-align:left; min-width: 70px;">{{ item.showName }}&nbsp;:&nbsp;</div>
              <div style="text-align:left;">{{ item.value }}</div>
            </div>
          </template>
          <template v-slot:billCycle="{ row }">
            <div>{{ handleCycle(row.billCycle) }}</div>
          </template>
          <template v-slot:effectTime="{ row }">
            <div>{{ timetrans(row.effectTime) }}</div>
            <div>{{ timetrans(row.expireTime) }}</div>
            <div v-if="row.preOrderID">
              继承自前序订单
              <router-link
                :to="{name: 'myorderDetails', params: {orderId: row.preOrderID}}"
              >{{row.preOrderID}}</router-link>
            </div>
            <div v-if="row.postOrderID">
              已由后续订单续费
              <router-link
                :to="{name: 'myorderDetails', params: {orderId: row.postOrderID}}"
              >{{row.postOrderID}}</router-link>
            </div>
          </template>
        </public-table>
      </div>
    </div>
    <div class="total_box" v-if="detailInfo">
      <div class="item">总价：{{ detailInfo.totalPrice }} 元</div>
      <div class="item">应付：{{ detailInfo.finalPrice }} 元</div>
    </div>
  </div>
</template>
<script>
import { errorHandle } from '@/utils/error';
import { timetrans } from '@/utils/validate';
import {
  handleOrderState,
  handleCycle,
  handleOrderType
} from '@/utils/dictionary';

export default {
  data() {
    return {
      timetrans,
      Loading: true,
      detailInfo: null,
      orderData: [],
      handleCycle,
      handleOrderState,
      handleOrderType,
      payStateTxt: '',
      column: [
        {
          prop: 'appName',
          label: '应用',
          scopeStatus: true
        },
        {
          prop: 'appVersion',
          label: '版本',
          width: '50px'
        },
        {
          prop: 'comboName',
          label: '套餐',
          width: '100px'
        },
        {
          prop: 'comboNamedetail',
          label: '套餐详情',
          align: 'left',
          scopeStatus: true
        },
        {
          prop: 'billCycle',
          label: '套餐周期',
          width: '100px',
          scopeStatus: true
        },
        {
          prop: 'comboQuantity',
          label: '数量',
          width: '50px'
        },
        {
          prop: 'effectTime',
          label: '起止时间',
          width: '260px',
          scopeStatus: true
        },
        {
          prop: 'totalPrice',
          label: '金额',
          width: '80px'
        }
      ]
    };
  },
  created() {
    const params = this.$route.params;
    this.orderId = params.orderId;
    this.getDetailInfo();
  },
  methods: {
    getDetailInfo() {
      this.$store
        .dispatch('GetMyOrderInfo', {
          orderID: this.orderId
        })
        .then((res) => {
          this.Loading = false;
          if (res) {
            this.detailInfo = res;
            this.payStateTxt =
              this.handleOrderState(res.state) +
              '（' +
              this.detailInfo.finalPrice +
              '元）';
            if (res.orderApps && res.orderApps.length) {
              this.orderData = res.orderApps;
            }
          }
        })
        .catch((err) => {
          this.Loading = false;
          errorHandle(err);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/myorder/details/index.vue